export const agileProjectManagementSolution = {
  title: 'Agile Project Management',
  name: 'AgileProjectManagement',
  description: 'Plan products, releases, sprints, assignments, and team priorities.',
  url: '/datatable/solutions/agile-project-management/',
  roles: ['user']
};

const normalizedUrl = (url) => typeof url === 'string' ? url.replace(/\/+$/, '') : '';

export const loadSolutions = (value) => {
  let solutions = value;

  if (typeof value === 'string') {
    try {
      solutions = JSON.parse(value);
    } catch (error) {
      solutions = [];
    }
  }

  if (!Array.isArray(solutions)) {
    solutions = [];
  }

  const agileUrl = normalizedUrl(agileProjectManagementSolution.url);
  let agileSolutionFound = false;
  const mergedSolutions = solutions.filter((solution) => {
    if (!solution || typeof solution !== 'object' || Array.isArray(solution)) {
      return false;
    }

    if (normalizedUrl(solution.url) !== agileUrl) {
      return true;
    }

    if (agileSolutionFound) {
      return false;
    }

    agileSolutionFound = true;
    return true;
  });

  return agileSolutionFound
      ? mergedSolutions
      : [...mergedSolutions, agileProjectManagementSolution];
};
